'use strict';
const Cart=window.EverteeCart;
const copy=window.EtPdp.config.reviewCopy;
const SIZES = ['S','M','L','XL','2XL','3XL','4XL'];
const COLOURS = {Green:'#616b49',Black:'#171918',Grey:'#b9b9b9',White:'#ffffff','Royal Blue':'#005bd3',Navy:'#242d45'};
const basePrice = n => Cart.packPrice(n)/100;
const PHOTO_DATA = {green:{name:'Green',finish:'Logo',alt:'Green Evertee Original Tshirt with logo on a seated model'},black:{name:'Black',finish:'Logo',alt:'Black Evertee Original Tshirt with logo, front view'},grey:{name:'Grey',finish:'Logo',alt:'Grey Evertee Original Tshirt with logo on a seated model'},white:{name:'White',finish:'Blank',alt:'White plain Evertee Tshirt on a seated model beside a plant'},'royal-blue':{name:'Royal Blue',finish:'Logo',alt:'Royal Blue Evertee Tshirt with chest logo on a standing model'},navy:{name:'Navy',finish:'Blank',alt:'Navy plain Evertee Tshirt on a standing model in jeans'},detail:{name:'Collar & fabric detail',alt:'Close-up of an olive Evertee collar, stitching and printed label'}};
const photoKey = colour => colour.toLowerCase().replaceAll(' ','-');
const photoCaption = key => PHOTO_DATA[key].finish ? (PHOTO_DATA[key].finish==='Blank'?'Plain Tshirt':PHOTO_DATA[key].finish)+' version pictured.' : 'Collar & fabric detail.';
const SIZE_CHART = [ ['S',35,37,19,27.5],['M',38,40,21,28.5],['L',41,43,22,29.5],['XL',44,46,24,30.5],['2XL',47,49,26,31],['3XL',50,52,28,31.5],['4XL',53,55,30,33] ];
const state = {count:3,fabric:'Standard',finish:'Blank',commonSize:'S',mixed:false,sameColour:false,delivery:'economy',photo:'green',units:'in',bag:[],tees:Array.from({length:6},()=>({colour:'Green',size:'S'}))};
const $ = s => document.querySelector(s);
const $$ = s => [...document.querySelectorAll(s)];
const money = value => '£'+value.toFixed(2);
const upgrade = () => state.fabric === 'Premium' ? 2 : 0;
const subtotal = () => basePrice(state.count)+state.count*upgrade();
const valid = () => state.tees.slice(0,state.count).every(t=>SIZES.includes(t.size));
const safe = text => String(text).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const announce = text => { $('#status-message').textContent=text; };

function renderSizes(){
 $('#sizes').innerHTML=SIZES.map(size=>`<label class="size-label"><input type="radio" name="size" value="${size}" ${state.commonSize===size?'checked':''}><span>${size}</span></label>`).join('');
}
let previousColourMix=null;
const SWATCH_ORDER=['Green','Black','White','Grey','Royal Blue','Navy'];
function swatches(index,colour){
 const shared=index==='all';
 return '<div class="swatch-list" role="group" aria-label="'+(shared?'Colour for all T-shirts':'Colour for Tshirt '+(index+1))+'">'+SWATCH_ORDER.map(name=>{
  const ink=['White','Grey'].includes(name)?'#131613':'#fff';
  return '<label class="colour-swatch" title="'+safe(name)+'" style="--swatch:'+COLOURS[name]+';--swatch-ink:'+ink+'"><input type="radio" name="tee-colour-'+index+'" value="'+safe(name)+'" '+(shared?'data-all-colour':'data-tee-colour="'+index+'"')+' '+(name===colour?'checked':'')+' aria-label="'+safe(name)+(shared?' for all T-shirts':' for Tshirt '+(index+1))+'"><span class="swatch-disc"><span class="swatch-check" aria-hidden="true">✓</span></span></label>';
 }).join('')+'</div>';
}
function teeSize(tee,index){
 if(!state.mixed)return '<span class="size-value sr-only">'+(tee.size||'Size?')+'</span>';
 return '<label class="individual-size"><span>Size</span><select data-tee-size="'+index+'" aria-label="Size for Tshirt '+(index+1)+'"><option value="">Choose</option>'+SIZES.map(size=>'<option '+(size===tee.size?'selected':'')+'>'+size+'</option>').join('')+'</select></label>';
}
function teeRow(tee,index,sizeOnly){
 return '<div class="tee-row'+(sizeOnly?' tee-size-row':'')+'"><div class="tee-row-header"><span class="tee-number">Tshirt '+(index+1)+'</span><strong class="tee-selected-colour" data-selected-colour="'+index+'">'+safe(tee.colour)+'</strong>'+teeSize(tee,index)+'</div>'+(sizeOnly?'':swatches(index,tee.colour))+'</div>';
}
function renderRows(){
 $('#same-colour').checked=state.sameColour;
 $('#colour-bulk-toolbar').hidden=state.count===1;
 $('#restore-colours').hidden=!previousColourMix;
 const shared=state.sameColour&&state.count>1;
 $('#tee-rows').innerHTML=shared?
  '<div class="tee-row common-colour-row"><div class="tee-row-header"><span>All '+state.count+' T-shirts</span><strong class="tee-selected-colour" data-selected-colour="all">'+safe(state.tees[0].colour)+'</strong></div>'+swatches('all',state.tees[0].colour)+'</div>'+(state.mixed?state.tees.slice(0,state.count).map((t,i)=>teeRow(t,i,true)).join(''):''):
  state.tees.slice(0,state.count).map((t,i)=>teeRow(t,i,false)).join('');
}
function applySharedColour(colour){
 state.tees.slice(0,state.count).forEach(tee=>tee.colour=colour);
}
function updateColourNote(colour,index){
 const photo=photoKey(colour);
 if(PHOTO_DATA[photo])choosePhoto(photo);
}
function chooseColour(colour,index){
 if(!Object.hasOwn(COLOURS,colour))return;
 if(index==='all')applySharedColour(colour);
 else{
  if(!Number.isInteger(index)||index<0||index>=state.count)return;
  state.tees[index].colour=colour;previousColourMix=null;$('#restore-colours').hidden=true;
 }
 $$('[data-selected-colour]').forEach(el=>{
  const n=el.dataset.selectedColour;
  el.textContent=n==='all'?state.tees[0].colour:state.tees[Number(n)].colour;
 });
 updateColourNote(colour,index);
 announce((index==='all'?'All '+state.count+' T-shirts':'Tshirt '+(index+1))+': '+colour+'.');
}
$('#restore-colours').addEventListener('click',()=>{
 if(!previousColourMix)return;
 previousColourMix.forEach((colour,i)=>{if(state.tees[i])state.tees[i].colour=colour;});
 previousColourMix=null;state.sameColour=false;
 renderRows();updateSummary();updateColourNote(state.tees[0].colour,0);
 $('#same-colour').focus();
 announce('Your previous colour mix has been restored. Your sizes are unchanged.');
});
function updateSummary(){
 $$('input[name="bundle"]').forEach(input=>input.checked=Number(input.value)===state.count);
 $('#pack-quantity').textContent=state.count+' '+(state.count===1?'Tshirt':'T-shirts');
 $('#fewer-tees').disabled=state.count<=3;
 $('#more-tees').disabled=state.count>=Cart.MAX_PACK;
 $('#more-tees').setAttribute('aria-label',state.count===1?'Make it three T-shirts':'Add one Tshirt');
 $('#pack-limit').hidden=state.count<Cart.MAX_PACK;
 const nextCount=state.count===1?3:state.count+1;
 $('#next-tee-price').textContent=state.count>=Cart.MAX_PACK?'24 per pack':(state.count===1?'Make it 3': 'Next Tshirt')+' +'+money(basePrice(nextCount)-basePrice(state.count)+(nextCount-state.count)*upgrade());
 $$('.bundle').forEach(el=>el.classList.toggle('selected',el.querySelector('input').checked));
 $('#premium-toggle').checked=state.fabric==='Premium';
 $$('input[name="finish"]').forEach(input=>input.checked=input.value===state.finish);
 $$('[data-bundle-total]').forEach(el=>{const n=Number(el.dataset.bundleTotal);el.textContent='£'+(basePrice(n)+n*upgrade());});
 $$('[data-unit]').forEach(el=>{const n=Number(el.dataset.unit);el.textContent=money((basePrice(n)+n*upgrade())/n)+' per Tshirt';});
 $('#fabric-description').textContent=state.fabric==='Standard'?'Standard selected. A lighter Tshirt for everyday wear.':`Premium selected. +${money(state.count*2)} for your ${state.count===1?'Tshirt':'whole bundle'}. Heavier, more substantial feel.`;
 $('#hero-bundle').textContent=`${state.count} ${state.count===1?'TSHIRT':'T-SHIRTS'}`;
 $('#hero-price').textContent='£'+subtotal();
 $('#add-label').textContent=valid()?`Add ${state.count===1?'Tshirt':'bundle'} to bag · ${money(subtotal())}`:'Choose your size';
 $('#sticky-title').textContent=`${state.count} ${state.fabric} ${state.count===1?'Tshirt':'T-shirts'} · ${money(subtotal())}`;
 $('#sticky-detail').textContent=window.EtPdp.config.popupCopy.delivery_checkout;
 $('#sticky-add').textContent=valid()?'Add to bag →':'Choose size →';
 if(valid())$('#size-error').hidden=true;
 window.EtPdp.sync(state);
 Cart.saveDraft({count:state.count,fabric:state.fabric,finish:state.finish,commonSize:state.commonSize,mixed:state.mixed,sameColour:state.sameColour,photo:state.photo,tees:state.tees.map(t=>({...t}))});
 document.dispatchEvent(new CustomEvent('pdp:selectionchange'));
}
function choosePhoto(key){
 if(!PHOTO_DATA[key])return;
 state.photo=key;
 const img=$('#hero-image');img.src=window.EtPdp.config.assets[key];img.alt=PHOTO_DATA[key].alt;
 $('#image-index').textContent=String(Object.keys(PHOTO_DATA).indexOf(key)+1).padStart(2,'0');
 $('#image-count').textContent=String(Object.keys(PHOTO_DATA).length).padStart(2,'0');
 $$('.gallery-thumbs button').forEach(b=>{const selected=b.dataset.photo===key;b.classList.toggle('active',selected);b.setAttribute('aria-pressed',String(selected));});
}
function ensureTees(count){
 while(state.tees.length<count){const previous=state.tees[state.tees.length-1]||{colour:'Green',size:''};state.tees.push({colour:state.sameColour?state.tees[0].colour:'Green',size:state.commonSize||previous.size});}
}
function setCount(count){
 if(!(count===1||Number.isInteger(count)&&count>=3&&count<=Cart.MAX_PACK))return;
 ensureTees(count);state.count=count;if(state.sameColour)applySharedColour(state.tees[0].colour);renderRows();updateSummary();
}
$('#more-tees').addEventListener('click',()=>{setCount(state.count===1?3:state.count+1);announceBundleQuantity();});
$('#fewer-tees').addEventListener('click',()=>{setCount(Math.max(3,state.count-1));announceBundleQuantity();});
const premiumReaction = (()=>{
 let image, timer, frame, objectUrl, requestId=0, nextIndex=0;
 const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
 const reactions=[{"url":"https://cdn.shopify.com/s/files/1/0879/0569/8058/files/evertee-premium-nice-smack.gif?v=1788889627","width":320,"height":260},{"url":"https://cdn.shopify.com/s/files/1/0879/0569/8058/files/evertee-premium-reaction-2.gif?v=1788890921","width":440,"height":300},{"url":"https://cdn.shopify.com/s/files/1/0879/0569/8058/files/evertee-premium-reaction-shaq.gif?v=1788890983","width":500,"height":500},{"url":"https://cdn.shopify.com/s/files/1/0879/0569/8058/files/evertee-premium-reaction-4.gif?v=1788891012","width":260,"height":229},{"url":"https://cdn.shopify.com/s/files/1/0879/0569/8058/files/evertee-premium-reaction-5.gif?v=1788891024","width":225,"height":169}];
 const downloads=new Map();
 const storageKey='et-premium-reaction-next-v1';
 try{
  const saved=Number(sessionStorage.getItem(storageKey));
  if(Number.isInteger(saved)&&saved>=0&&saved<reactions.length)nextIndex=saved;
 }catch{}
 function loadGif(index){
  if(!downloads.has(index))downloads.set(index,fetch(reactions[index].url,{credentials:'omit'})
   .then(response=>{if(!response.ok)throw new Error('Reaction unavailable');return response.blob();})
   .catch(error=>{downloads.delete(index);throw error;}));
  return downloads.get(index);
 }
 function dismiss(){
  requestId++;
  clearTimeout(timer);
  cancelAnimationFrame(frame);
  if(image){image.remove();image=null;}
  if(objectUrl){URL.revokeObjectURL(objectUrl);objectUrl=null;}
 }
 function warmUp(){if(!reducedMotion.matches)loadGif(nextIndex).catch(()=>{});}
 const control=$('#premium-toggle-section');
 control.addEventListener('pointerenter',warmUp);
 control.addEventListener('focusin',warmUp);
 window.addEventListener('pagehide',dismiss);
 document.addEventListener('keydown',event=>{if(event.key==='Escape')dismiss();});
 reducedMotion.addEventListener('change',event=>{if(event.matches)dismiss();});
 return async enabled=>{
  dismiss();
  if(!enabled||reducedMotion.matches)return;
  const activeRequest=requestId;
  const reactionIndex=nextIndex;
  const reaction=reactions[reactionIndex];
  try{
   const blob=await loadGif(reactionIndex);
   if(activeRequest!==requestId||reducedMotion.matches||!$('#premium-toggle').checked)return;
   image=document.createElement('img');
   image.className='et-premium-reaction';
   image.alt='';
   image.setAttribute('aria-hidden','true');
   image.width=reaction.width;
   image.height=reaction.height;
   image.style.setProperty('--reaction-ratio',String(reaction.width/reaction.height));
   image.hidden=true;
   image.draggable=false;
   image.addEventListener('load',()=>{
    if(activeRequest!==requestId)return;
    image.hidden=false;
    frame=requestAnimationFrame(()=>{
     if(activeRequest!==requestId)return;
     image.classList.add('is-visible');
     nextIndex=(reactionIndex+1)%reactions.length;
     try{sessionStorage.setItem(storageKey,String(nextIndex));}catch{}
     timer=setTimeout(dismiss,2200);
    });
   },{once:true});
   image.addEventListener('error',()=>{if(activeRequest===requestId)dismiss();},{once:true});
   document.body.append(image);
   objectUrl=URL.createObjectURL(blob);
   image.src=objectUrl;
  }catch{if(activeRequest===requestId)dismiss();}
 };
})();
let premiumMotionTimer;
function premiumFeedback(enabled){
 premiumReaction(enabled);
 const row=$('#premium-toggle-section');
 clearTimeout(premiumMotionTimer);
 row.classList.remove('is-celebrating');
 if(!enabled||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 void row.offsetWidth;
 row.classList.add('is-celebrating');
 premiumMotionTimer=setTimeout(()=>row.classList.remove('is-celebrating'),500);
}
function setFabric(value){
 if(!['Standard','Premium'].includes(value))return;
 const changed=state.fabric!==value;
 state.fabric=value;
 updateSummary();
 if(changed)premiumFeedback(value==='Premium');
 announce(`${value} selected. Bundle price ${money(subtotal())}. Your sizes and colours have been kept.`);
}
function setFinish(value){
 if(!['Blank','With logo'].includes(value))return;
 state.finish=value;
 updateSummary();
 announce(`${state.finish==='Blank'?'Plain Tshirt':state.finish} selected for all ${state.count} ${state.count===1?'Tshirt':'T-shirts'}. Your sizes and colours have been kept.`);
}

$('#product-form').addEventListener('change',event=>{
 const el=event.target;
 if(el.name==='bundle')setCount(Number(el.value));
 if(el.id==='premium-toggle'){setFabric(el.checked?'Premium':'Standard');return;}
 if(el.name==='finish'){setFinish(el.value);return;}
 if(el.name==='size'){
  state.commonSize=el.value;
  state.tees.forEach(t=>t.size=el.value);
  renderRows();announce(`Size ${el.value} applied to all T-shirts.`);
 }
 if(el.id==='mixed'){
  state.mixed=el.checked;
  if(!state.mixed){state.commonSize=state.commonSize||state.tees[0].size;state.tees.forEach(t=>t.size=state.commonSize);renderSizes();}
  renderRows();
 }
 if(el.id==='same-colour'){
  state.sameColour=el.checked;
  if(state.sameColour){
   previousColourMix=state.tees.map(t=>t.colour);
   applySharedColour(state.tees[0].colour);
   updateColourNote(state.tees[0].colour,'all');
   announce('All '+state.count+' T-shirts are '+state.tees[0].colour+'. Pick a colour below to change all of them. Undo restores your previous mix.');
  }else{
   previousColourMix=null;
   announce('You can choose each colour individually. Your current colours are kept.');
  }
  renderRows();
 }
 if(el.dataset.teeColour!==undefined)chooseColour(el.value,Number(el.dataset.teeColour));
 if(el.hasAttribute('data-all-colour'))chooseColour(el.value,'all');
 if(el.dataset.teeSize!==undefined){state.tees[Number(el.dataset.teeSize)].size=el.value;state.commonSize='';renderSizes();}
 updateSummary();
});

function validateBundleSelection(){
 if(!valid()){
  $('#size-error').hidden=false;
  const target=state.mixed?Array.from(document.querySelectorAll('[data-tee-size]')).find(el=>!el.value):$('input[name="size"]');
  (target||$('#size-section')).scrollIntoView({behavior:'smooth',block:'center'});
  if(target)target.focus({preventScroll:true});
  return false;
 }
 $('#size-error').hidden=true;
 return true;
}
async function submitBundle(event){
 if(event)event.preventDefault();
 if(!validateBundleSelection())return;
 await window.EtPdp.add(state);
}
$('#product-form').addEventListener('submit',submitBundle);
$('#sticky-add').addEventListener('click',submitBundle);
const modal=$('#modal');
let modalOpener=null, modalScrollY=0, modalOverflow='';
modal.querySelector('.close').addEventListener('click',()=>modal.close());
modal.addEventListener('click',event=>{if(event.target===modal){const r=modal.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)modal.close();}});
modal.addEventListener('close',()=>{document.body.style.overflow=modalOverflow;window.scrollTo({top:modalScrollY,behavior:'instant'});if(modalOpener?.isConnected)modalOpener.focus({preventScroll:true});});

function sizeContent(){
 const factor=state.units==='cm'?2.54:1;
 const fmt=n=>Number((n*factor).toFixed(1));
 return `<p>${safe(copy.compare_measurements)}</p><div class="modal-tabs" role="group" aria-label="Measurement units"><button data-unit-choice="in" class="${state.units==='in'?'active':''}" aria-pressed="${state.units==='in'}">Inches</button><button data-unit-choice="cm" class="${state.units==='cm'?'active':''}" aria-pressed="${state.units==='cm'}">Centimetres</button></div><div class="table-scroll"><table class="modal-table"><caption>${safe(copy.chart_label)} · ${state.units==='in'?'inches':'centimetres'}</caption><thead><tr><th>Size</th><th>Body chest</th><th>Tshirt width</th><th>Tshirt length</th></tr></thead><tbody>${SIZE_CHART.map(([s,a,b,w,l])=>`<tr><th>${s}</th><td>${fmt(a)}–${fmt(b)}</td><td>${fmt(w)}</td><td>${fmt(l)}</td></tr>`).join('')}</tbody></table></div><p class="micro">Body chest is measured all the way around you. Tshirt width is measured straight across a Tshirt laid flat, under the arms.</p><img class="size-illustration" src="${window.EtPdp.config.assets.sizeGuide}" width="200" height="200" alt="How to measure chest, flat T-shirt width and length"><div class="modal-callout"><b>Between sizes?</b>${safe(copy.between_sizes)}</div><p>${safe(copy.fabric_fit)}</p><a class="modal-button" href="https://www.evertee.co.uk/pages/contact" target="_blank" rel="noopener">Ask for help with my fit ↗</a>`;
}
function deliveryContent(){
 const c=window.EtPdp.config.popupCopy;
 return `<p>${safe(c.delivery_details)}</p><p>${safe(c.delivery_timing)}</p><button type="button" class="modal-button" data-close>${safe(c.back_to_bundle)}</button>`;
}
function priceContent(){
 const c=window.EtPdp.config.popupCopy;
 return `<p>${state.count} ${safe(state.fabric)} ${state.count===1?'Tshirt':'T-shirts'} · ${safe(state.finish==='Blank'?'Plain Tshirt':state.finish)}</p><dl class="popup-price"><div><dt>${safe(c.pack_label)}</dt><dd>${money(basePrice(state.count))}</dd></div>${state.fabric==='Premium'?`<div><dt>${safe(c.premium_label)}</dt><dd>+${money(state.count*2)}</dd></div>`:''}<div><dt>${safe(c.guarantee_label)}</dt><dd>${safe(c.included)}</dd></div><div class="popup-price-total"><dt>${safe(c.bundle_total)}</dt><dd>${money(subtotal())}</dd></div></dl><p>${safe(c.bundle_note)}</p><p class="popup-small">${safe(c.guarantee_note)}</p><p class="popup-small">${safe(c.delivery_checkout)}</p><button type="button" class="modal-button" data-close>${safe(c.back_to_bundle)}</button>`;
}
function colourContent(photo=state.photo){
 const c=window.EtPdp.config.popupCopy;
 const selected=Object.hasOwn(PHOTO_DATA,photo)?photo:'green';
 const info=PHOTO_DATA[selected];
 const finish=$('.finish-comparison').outerHTML;
 return `<div class="popup-colour-tabs" role="group" aria-label="${safe(c.photo_group)}">${Object.entries(PHOTO_DATA).map(([key,p])=>`<button type="button" data-modal-photo="${safe(key)}" aria-pressed="${key===selected}">${safe(p.name)}</button>`).join('')}</div><img class="popup-colour-image" src="${safe(window.EtPdp.config.assets[selected])}" alt="${safe(info.alt)}" width="800" height="800"><p class="popup-photo-caption">${safe(info.name)} · ${safe(photoCaption(selected))}</p><p class="popup-small">${safe(c.photo_note)}</p><div class="finish-explainer"><h3>${safe($('#finish-explainer-heading').textContent)}</h3><p class="finish-intro">${safe($('.finish-intro').textContent)}</p>${finish}<p class="finish-illustration-note">${safe($('.finish-illustration-note').textContent)}</p></div><button type="button" class="modal-button" data-close>${safe(c.back_to_bundle)}</button>`;
}
function openModal(kind,opener){
 let title='',body='';
 if(kind==='price'){title=window.EtPdp.config.popupCopy.price_title;body=priceContent();}
 if(kind==='colours'){title=window.EtPdp.config.popupCopy.colour_title;body=colourContent();}
 if(kind==='reviews'){title='THE REVIEWS.';body='<div id="tp-review-archive"></div>';}
 if(kind==='size'){title='A good fit starts here.';body=sizeContent();}
 if(kind==='compare'){title='Which fabric is for you?';body=`<p>Choose the feel you prefer. Premium is a fabric upgrade, with no membership involved.</p><table class="modal-table"><thead><tr><th></th><th>Standard</th><th>Premium</th></tr></thead><tbody><tr><th>Feel</th><td>Lighter</td><td>Heavier</td></tr><tr><th>Bundle upgrade</th><td>Included</td><td>+${money(state.count*2)}</td></tr><tr><th>Your ${state.count}-Tshirt total</th><td>${money(basePrice(state.count))}</td><td>${money(basePrice(state.count)+state.count*2)}</td></tr><tr><th>Lifetime cover*</th><td>Included</td><td>Included</td></tr></tbody></table><p>${safe(copy.fabric_fit)}</p><div class="modal-tabs"><button data-choose-fabric="Standard" class="${state.fabric==='Standard'?'active':''}">Choose Standard</button><button data-choose-fabric="Premium" class="${state.fabric==='Premium'?'active':''}">Choose Premium</button></div><p class="micro">Delivery is calculated separately at checkout.</p>`;}
 if(kind==='delivery'){title='Delivery, without surprises.';body=deliveryContent();}
 if(kind==='returns'){title='Returns & exchanges.';body=`<p>${safe(copy.returns_intro)}</p><h3>Promotional bundles</h3><p>${safe(copy.returns_promo)}</p><h3>Returns and postage</h3><p>${safe(copy.returns_conditions)}</p><p>${safe(copy.returns_postage)}</p><h3>Need a different size?</h3><p>${safe(copy.returns_exchange)}</p><h3>Faulty or incorrect item?</h3><p>${safe(copy.returns_fault)}</p><a class="modal-button" href="https://www.evertee.co.uk/apps/returns-portal">${safe(copy.returns_start)}</a><p><a href="https://www.evertee.co.uk/policies/refund-policy">${safe(copy.returns_terms)}</a></p>`;}
 if(kind==='cart'){window.location.assign(window.EtPdp.config.cartUrl);return;}
 if(kind==='zoom'){title=PHOTO_DATA[state.photo].name;body=`<img class="zoom-image" src="${window.EtPdp.config.assets[state.photo]}" alt="${PHOTO_DATA[state.photo].alt}"><p class="micro">${photoCaption(state.photo)} Your chosen finish is unchanged.</p>`;}
 modal.dataset.kind=kind;
 $('#modal-title').textContent=title;$('#modal-body').innerHTML=body;
 if(!modal.open){modalOpener=opener||document.activeElement;modalScrollY=window.scrollY;modalOverflow=document.body.style.overflow;modal.showModal();document.body.style.overflow='hidden';}
 modal.scrollTop=0;
 if(kind==='reviews')window.EverteeReviews.mount($('#tp-review-archive'));
}
document.addEventListener('click',event=>{
 const modalPhoto=event.target.closest('[data-modal-photo]');if(modalPhoto){event.preventDefault();const key=modalPhoto.dataset.modalPhoto;if(Object.hasOwn(PHOTO_DATA,key)){$('#modal-body').innerHTML=colourContent(key);modal.querySelector('[data-modal-photo="'+key+'"]').focus({preventScroll:true});}return;}
 const photo=event.target.closest('[data-photo]');if(photo)choosePhoto(photo.dataset.photo);
 const trigger=event.target.closest('[data-dialog]');if(trigger){event.preventDefault();openModal(trigger.dataset.dialog,trigger);}
 const close=event.target.closest('[data-close]');if(close)modal.close();
 const fabric=event.target.closest('[data-choose-fabric]');if(fabric){setFabric(fabric.dataset.chooseFabric);if(modal.open)modal.close();$('#product-form').scrollIntoView({behavior:'smooth',block:'start'});}
 const unit=event.target.closest('[data-unit-choice]');if(unit){state.units=unit.dataset.unitChoice;$('#modal-body').innerHTML=sizeContent();$(`[data-unit-choice="${state.units}"]`).focus();}
});
function announceBundleQuantity(){
 announce(state.count+' T-shirts. Bundle price '+money(subtotal())+'.');
}
const stickyObserver=new IntersectionObserver(entries=>{const entry=entries[0];$('#sticky-buy').hidden=entry.isIntersecting||entry.boundingClientRect.top>0;},{threshold:0});
stickyObserver.observe($('#add-button'));
const draft=Cart.readDraft();
if(draft&&typeof draft==='object'){
 if(draft.count===1||Number.isInteger(draft.count)&&draft.count>=3&&draft.count<=Cart.MAX_PACK)state.count=draft.count;
 ensureTees(Math.max(state.count,Math.min(Cart.MAX_PACK,draft.tees?.length||0)));
 if(['Standard','Premium'].includes(draft.fabric))state.fabric=draft.fabric;
 if(['Blank','With logo'].includes(draft.finish))state.finish=draft.finish;
 state.commonSize=SIZES.includes(draft.commonSize)?draft.commonSize:draft.mixed===true?'':SIZES.includes(draft.tees?.[0]?.size)?draft.tees[0].size:'S';
 state.mixed=draft.mixed===true;
 state.sameColour=draft.sameColour===true;
 if(PHOTO_DATA[draft.photo])state.photo=draft.photo;
 if(Array.isArray(draft.tees))state.tees=state.tees.map((t,i)=>({colour:Object.hasOwn(COLOURS,draft.tees[i]?.colour)?draft.tees[i].colour:t.colour,size:SIZES.includes(draft.tees[i]?.size)?draft.tees[i].size:state.commonSize||'S'}));
 if(!state.mixed)state.tees.forEach(t=>t.size=state.commonSize);
 if(state.sameColour)applySharedColour(state.tees[0].colour);
}
state.delivery=Cart.read().delivery;
$$('input[name="bundle"]').forEach(input=>input.checked=Number(input.value)===state.count);
$('#premium-toggle').checked=state.fabric==='Premium';
$$('input[name="finish"]').forEach(input=>input.checked=input.value===state.finish);
$('#mixed').checked=state.mixed;
renderSizes();renderRows();choosePhoto(state.photo);updateSummary();
async function refreshBag(){await window.EtPdp.refreshCart();updateSummary();}
refreshBag();window.addEventListener('pageshow',refreshBag);
window.EtPdp.ready.then(()=>updateSummary()).catch(()=>updateSummary());






